import type { ReactText } from "react";
import * as palette from "../../palette";

interface IMenuTitleProps {
  children: ReactText;
}

export default function MenuTitle({ children }: IMenuTitleProps) {
  return (
    <li
      css={{
        paddingTop: 8,
        paddingBottom: 8,
      }}
    >
      <h6
        css={{
          margin: 0,

          color: palette.fiord,
          fontWeight: "bold",
          fontSize: 12,
          lineHeight: 1.33,
          textTransform: "uppercase",
        }}
      >
        {children}
      </h6>
    </li>
  );
}
